// Gift guide carousels (TSK-11506).
// Listeners sit on the document or on custom elements, so they survive the theme editor re-rendering a section.

// Shop rail arrows
if (!customElements.get('gift-guide-rail')) {
  customElements.define(
    'gift-guide-rail',
    class GiftGuideRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gg-rail__track');
        this.onClick = (event) => {
          const button = event.target.closest('[data-gg-rail-dir]');
          if (!button || !this.track) return;
          this.track.scrollBy({ left: Number(button.dataset.ggRailDir) * this.track.clientWidth });
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
    }
  );
}

// Mouse drag-to-scroll for [data-gg-drag] rows. Touch already scrolls natively, so only mouse pointers are handled.
if (!window.giftGuideDragScroll) {
  window.giftGuideDragScroll = true;

  const DRAG_THRESHOLD = 5;
  let drag = null;

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const row = event.target.closest('[data-gg-drag]');
    if (!row || row.scrollWidth <= row.clientWidth) return;
    drag = { row, startX: event.clientX, startScroll: row.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag) return;
    const dx = event.clientX - drag.startX;
    if (!drag.moved) {
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      drag.moved = true;
      drag.row.classList.add('is-dragging');
    }
    event.preventDefault();
    drag.row.scrollLeft = drag.startScroll - dx;
  });

  const endDrag = () => {
    if (!drag) return;
    if (drag.moved) {
      drag.row.classList.remove('is-dragging');
      // Swallow the click that follows a drag so links in the row aren't followed.
      document.addEventListener('click', (event) => event.preventDefault(), { capture: true, once: true });
    }
    drag = null;
  };
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // Stop the browser's native image/link ghost-drag from taking over.
  document.addEventListener('dragstart', (event) => {
    if (event.target.closest && event.target.closest('[data-gg-drag]')) event.preventDefault();
  });
}

// Scroll reveal for [data-gg-reveal] and [data-gg-reveal-group]. Re-runs on shopify:section:load so editor re-renders animate too.
if (!window.giftGuideReveal) {
  window.giftGuideReveal = true;

  const SELECTOR = '[data-gg-reveal]:not(.is-revealed), [data-gg-reveal-group]:not(.is-revealed)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer =
    'IntersectionObserver' in window && !reduceMotion
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        )
      : null;

  const reveal = (root) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (observer) observer.observe(el);
      else el.classList.add('is-revealed');
    });
  };

  reveal(document);
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
}
